import { createContext } from 'react';
import config from '../clientConfigs';
import APP_ENV from '../config/appEnv';

const AppConfigContext = createContext({
    companyId: APP_ENV.CLIENT_ID,
    config: config[APP_ENV.CLIENT_SHORT_NAME]
});

export default AppConfigContext;
